<div class="pr-input-icon-multiselect">
  <div class="pr-input-label">{{ label }}</div>
  <div class="pr-input-icon-multiselect-options">
    @for (option of options; track option) {
      <label>
        <input
          type="checkbox"
          [value]="option.value"
          [checked]="checked(option.value)"
          (change)="onInputChange($event)"
        />
        <div class="pr-input-icon-multiselect-option">
          <pr-icon [name]="option.icon"></pr-icon>
          <div>{{ option.label }}</div>
        </div>
      </label>
    }
  </div>
  <pr-errors [derrors]="derrors" [control]="control"></pr-errors>
</div>
